import React from "react";
import { Primitive, PrimitiveProps } from "../primitive/primitive";

// --- Button Component ---

interface ButtonProps extends PrimitiveProps<"button"> {}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ children, as = "button", ...props }, ref) => {
    return (
      <Primitive as={as} ref={ref} whileTap={{ scale: 0.95 }} {...props}>
        {children}
      </Primitive>
    );
  },
);

Button.displayName = "Button";

// --- Export ---

export { Button, type ButtonProps };
